import { createFileRoute } from '@tanstack/react-router';
import { InvoiceEditor } from '@/components/custom/invoice-editor';

/**
 * Raising an invoice.
 *
 * A route rather than a dialog on the list, and nothing is written until the
 * user saves: `create` allocates an invoice number, and the sequence only ever
 * moves forward. Raising an empty draft up front would burn a number on every
 * abandoned attempt and leave a gap in the tenant's numbering.
 *
 * Static segment, so it wins over `$id` in the router's match order.
 */
export const Route = createFileRoute('/_authenticated/invoices/new')({
  component: NewInvoicePage,
});

function NewInvoicePage() {
  return <InvoiceEditor invoiceId={null} />;
}
